import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ontruck/orc';
import { useHistory, useParams } from 'react-router-dom';
import { ROUTES } from 'utils/constants/routes';
import { useTranslation } from 'react-i18next';

const DocumentsWelcomeBullet = ({ number, children }) => {
  return (
    <div className="documents-welcome__bullet">
      <span className="documents-welcome__bullet-icon">{number}</span>
      <span className="documents-welcome__bullet-text">{children}</span>
    </div>
  );
};

const DocumentsWelcome = ({ className }) => {
  const { uuid } = useParams();
  const history = useHistory();
  const { t } = useTranslation('Documents');

  const handleStart = useCallback(() => {
    history.push(ROUTES.DOCS_BILLING_DATA.DEFAULT(uuid));
  }, [history, uuid]);

  return (
    <div className={className} data-testid="documents-welcome">
      <div className="documents-welcome">
        <div className="documents-welcome__container">
          <h2 className="documents-welcome__title">{t('step0Title')}</h2>
          <div className="documents-welcome__description">
            {t('step0Description')}
          </div>
          <div className="documents-welcome__bullet-container">
            <DocumentsWelcomeBullet number="1">
              {t('completeBilling')}
            </DocumentsWelcomeBullet>
            <DocumentsWelcomeBullet number="2">
              {t('completeDocuments')}
            </DocumentsWelcomeBullet>
          </div>
          <Button
            skin="primary"
            className="documents-welcome__action"
            onClick={handleStart}
            text={t('start')}
            data-testid="documents-welcome__action"
          />
        </div>
      </div>
    </div>
  );
};
DocumentsWelcome.propTypes = {
  className: PropTypes.string
};
export default DocumentsWelcome;
